var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"table-item"},[_c('td',[_c('v-checkbox',{attrs:{"ripple":false,"hide-details":""},model:{value:(_vm.isActive),callback:function ($$v) {_vm.isActive=$$v},expression:"isActive"}})],1),_c('td',[_vm._v("\n    "+_vm._s(_vm.item.name)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }